import { useContext } from 'react';
import { useAPI } from '../lib/hooks';
import useRestService from './RestService';
import { AppContext } from '../sporttia/AppContext';
import constants from '../config/constants';

const resource = '/in-app-notifications';

/**
 * Hook to access all 'in-app-notifications' resources.
 */
export default function useInAppNotificationsService() {
    const { migrationApis } = useContext(AppContext)!;
    const [request] = useAPI(migrationApis);
    const services = useRestService(resource);

    /**
     * PUT /in-app-notifications/:id/read request.
     * @param id In-app notification ID.
     * @param params Resource parameters to be sent with the request.
     * @returns {Promise<unknown>|*} Return request promise.
     */
    function markAsRead(
        id: string | number,
        params?: Record<string, unknown>,
    ): Promise<unknown> {
        return request(
            'PUT',
            `${constants.boundedContextPrefixes.COMMUNICATIONS}${resource}/${id}/read`,
            params,
        );
    }

    return {
        ...services,
        markAsRead,
    };
}
